import axios from 'axios'


const api = axios.create({
    baseURL: "https://api.themoviedb.org/3/",
    params: {
        api_key: process.env.REACT_APP_APIKey,
        language: "en-US"
        // 'ko-KR's
    }
})

export const moviesApi = {
    nowPlaying: (id) => api.get('movie/now_playing', { params: { page: id } }),
    upcoming: (id) => api.get('movie/upcoming', { params: { page: id } }),
    popular: (id) => api.get('movie/popular', { params: { page: id } }),
    movieRecommendations: (id) => api.get(`movie/${id}/recommendations`),
    movieCredits: id => api.get(`movie/${id}/credits`),
    movieLatest: () => api.get('discover/movie'),
    movieDetail: id => api.get(`movie/${id}`, {
        params: {
            append_to_response: "videos,images"
        }
    }),
    search: (term, page) => api.get('search/movie', {
        params: {
            query: term,
            page
        }
    }),
    castPeople: id => api.get(`/person/${id}`, {
        params: {
            append_to_response: "videos,images"
        }
    })
}

export const tvApi = {
    topRated: (id) => api.get('tv/top_rated', { params: { page: id } }),
    popular: (id) => api.get('tv/popular', { params: { page: id } }),
    airingToday: (id) => api.get('tv/airing_today', { params: { page: id } }),
    tvRecommendations: (id) => api.get(`tv/${id}/recommendations`),
    tvImdb: (id) => api.get(`tv/${id}/external_ids`),
    tvCredits: id => api.get(`tv/${id}/credits`),
    tvSeasons: (id, season) => api.get(`tv/${id}/season/${season}`),
    tvDetail: id => api.get(`tv/${id}`, {
        params: {
            append_to_response: "videos,images"
        }
    }),
    search: (term, page) => api.get(`search/tv`, {
        params: {
            query: term,
            page
        }
    })
}
